import {
  getInitFormData,
} from './utils.js';

export default {
  name: 'BDOMerchantFormForm',
  model: {
    prop: 'formData',
    event: 'change'
  },  
  props: [
    'formData',
    'toggleContact', // 控制表单字段的显示隐藏 eg: moreContact
    'labelArray',    // BdoRadio component parameter (BdoRadio 组件按钮文案)
    'mode',          // BdoRadio component parameter (BdoRadio 组件是否必选)
    'toggleAcr',     // acrNumber show hidden ( acrNumber 显示隐藏)
    'selectOptions', // select option  (下拉框选项)
    'agencyBanking', // BusinessNature下来列表选择
    'disabled',
  ],
  data() {
    return {
      dFormData: {},
      options: {},
      bdoRadioLabelArray: [],
      bdoRadioMode: true,
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // 将v-model传入的数据更新到组件data
      this.dFormData = Object.assign({}, this.dFormData, this.$props.formData);
      this.options = this.selectOptions ? this.selectOptions : {};
      
      // BdoRadio component parameter
      this.bdoRadioLabelArray = this.labelArray ? this.labelArray : [];
      this.bdoRadioMode = this.mode ? this.mode : true;
    })
  },
  methods: {
    // 更新 formData
    updateDataForm(val){
      this.dFormData = Object.assign({}, val);
    },
  },
  watch: {
    dFormData: function() {
      this.$emit('change', this.$data.dFormData)
    },
  },
   // 模板字符串同时存在 ''  和 ""  而做的处理
  template: `<div><el-form class="pc-wrap BDOMerchantForm" label-position="top" ref="appForm" label-width="80px" :model="dFormData" :rules="formRules" :validateOnRuleChange="false" ><el-form-item   label="First Name" prop="firstName"><el-input v-model="dFormData.firstName"  placeholder="First Name" maxlength="30" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><el-form-item  label="Mobile Number" prop="mobile"><MobileNumber v-model="dFormData.mobile"></MobileNumber></el-form-item><el-form-item   label="Middle Name (optional)" prop="middleName"><el-input v-model="dFormData.middleName"  placeholder="Middle Name" maxlength="16" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><div class="el-form-item"></div><el-form-item class="left-box"  label="Last Name" prop="lastName"><el-input v-model="dFormData.lastName"  placeholder="Last Name" maxlength="16" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><el-form-item class="right-box"  label="Suffix (optional)" prop="suffix"><el-input v-model="dFormData.suffix"  placeholder="Sr., Jr., III" maxlength="8" :clearable="!disabled" :disabled="disabled"></el-input></el-form-item><el-form-item   label="Email Address" prop="email"><el-input v-model="dFormData.email"  placeholder="Email Address" maxlength="32" :clearable="false" :disabled="disabled"></el-input></el-form-item><hr class="divider" /><el-form-item label="New Password" prop="mchPassword"><NewPassword  v-model="dFormData.mchPassword" /></el-form-item><div class="el-form-item"></div><el-form-item label="Confirm New Password" prop="confirmPassword"><ConfirmPassword v-model="dFormData.confirmPassword" /></el-form-item></el-form></div>`,
};